import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class DevicePairingApi {

    static create() {
        return HTTP.post(config.devicePairingApi.create)
            .then(response => response.data);
    }

    static redeem(token) {
        return HTTP.post(config.devicePairingApi.redeem, {token})
            .then(response => response.data);
    }
}
